module.exports = __webpack_public_path__ + "img/savta_no.f2e9e5bb.png";